import {COURSES,type CourseId} from './course-catalog';
// The name a parent sees for a course: on the dashboard (client/math/course-presentation.ts) and in email.
export function courseLabel(id:CourseId){
 if(id==='k4')return 'Pre-K (age 4)';if(id==='k5')return 'Kindergarten';if(id==='early')return 'Legacy number foundations';
 return COURSES.find(c=>c.id===id)!.name.replace(/^Puzzle Adventures · /,'');
}
